import graphqlClient from '../../api/axios_interceptor';
import {
    AddTenantMutation, DeleteTenantMutation, GetAllTenantsDataQuery,
    UpdateTenantMutation, getTenantsQuery, GetTenantInUnitMutation,
    queryPropertyTenants,
    ShiftTenantMutation,
    GetTenantDataQuery
} from '../../api/graphql/queries/tenant';
import { ADD_TENANT, DELETE_TENANT, LOAD_PROPERTIES,
    FETCH_TENANTS, UPDATE_TENANT, GET_TENANT_IN_UNIT, FETCH_PROPERTY_TENANTS, SHIFT_TENANT, FETCH_TENANT_DATA
} from '../actions/actionTypes';
import { updateActionErrors } from './updateErrors';
import { FormDataRestClient } from '../../api/rest_interceptor';
import { GRAPHQL_API } from '../../api/graphql/endpoint';
import { getFormData } from './functions';
import { fetchUnitsForProperties } from '../actions/units';


export const parseTenant = (tenant) => {
    let deposits = [];
    try {
        deposits = tenant.depositJson ? JSON.parse(tenant.depositJson) : [];
    } catch (e) {
        deposits = [];
    }
    let nextOfKin = [];
    try {
        if (Array.isArray(tenant.nextOfKin)) {
            nextOfKin = tenant.nextOfKin;
        } else if (typeof tenant.nextOfKin === 'string' && tenant.nextOfKin.length > 0) {
            nextOfKin = JSON.parse(tenant.nextOfKin) || [];
        }
    } catch (e) {
        nextOfKin = [];
    }
    return ({
        tenantId: tenant.tenantId,
        unitId: tenant.unitId,
        propertyId: tenant.propertyId,
        firstName: tenant.firstName,
        lastName: tenant.lastName,
        email: tenant.email,
        phoneNumber: tenant.phoneNumber,
        accountBalance: tenant.accountBalance,
        deposits,
        rentAmount: tenant.rentAmount || "",
        moveInDate: tenant.moveInDate ? new Date(tenant.moveInDate) : "",
        moveOutDate: tenant.moveOutDate ? new Date(tenant.moveOutDate) : "",
        leaseStartDate: tenant.leaseStartDate ? new Date(tenant.leaseStartDate) : "",
        leaseEndDate: tenant.leaseEndDate ? new Date(tenant.leaseEndDate) : "",
        penaltyType: tenant.penaltyType? tenant.penaltyType.toUpperCase(): "" ,
        fixedPenaltyAmount: tenant.fixedPenaltyAmount,
        percentagePenaltyAmount: tenant.percentagePenaltyAmount,
        automaticallyPenalize: tenant.automaticallyPenalize,
        penaltyDayOfMonth: tenant.penaltyDayOfMonth,
        notes: tenant.notes ? tenant.notes : "",
        accountId: tenant.accountId ? tenant.accountId : "",
        nationalIdNumber: tenant.nationalIdNumber ? tenant.nationalIdNumber : "",
        taxPin: tenant.taxPin? tenant.taxPin: "",
        archived: tenant.archived,
        fileName: tenant.upload? tenant.upload.file : "",
        fileId: tenant.upload? tenant.upload.id : "",
        otherPhoneNumbers: tenant.otherPhoneNumbers? tenant.otherPhoneNumbers : [],
        nextOfKin,
        bankPayerNames: tenant.bankPayerNames? tenant.bankPayerNames : [],
    });
}


export const parseInvoiceTenantDetails = (tenant) => ({
    tenantId: tenant.id,
    firstName:tenant.user.firstName,
    lastName:tenant.user.lastName,
    unitId:tenant.unit.id,
    propertyId:tenant.unit.property.id
});

const tenantsMiddleware = storeAPI => next => async action => {
    const refreshUnitsForProperties = (propertyIds=[]) => {
        const uniquePropertyIds = [...new Set((propertyIds || []).filter(Boolean))];
        if (uniquePropertyIds.length > 0) {
            storeAPI.dispatch(fetchUnitsForProperties(uniquePropertyIds));
        }
    };
    switch (action.type) {
        case FETCH_TENANTS:
            action = await fetchTenantsMiddleware(action);
            break;
        case FETCH_PROPERTY_TENANTS:
            action = await fetchPropertyTenantsMiddleware(action);
            break;
        case GET_TENANT_IN_UNIT:
            try {
                let payload = action.payload;
                const query = GetTenantInUnitMutation(payload.unitId);
                await graphqlClient({
                    data: {
                        query: query
                    }
                }).then((queryResult) => {
                    if (queryResult.data.errors) {
                        action = updateActionErrors(action, queryResult.data.errors);
                    }  else if (queryResult.data.data.unitTenant === null){
                        action = updateActionErrors(action, "This unit is not occupied");
                    } else {
                        let tenant = parseInvoiceTenantDetails(queryResult.data.data.unitTenant);

                        action = ({
                            ...action,
                            payload: {
                                ...action.payload,
                                tenant
                            }
                        });
                    }

                });
            } catch (error) {
                console.error(error);
                action = updateActionErrors(action, error)
            }


            break;
        case ADD_TENANT:
            try {
                let tenant = action.payload;
                const query = AddTenantMutation(tenant);
                const formData = getFormData(query, action.payload.fileUpload);
                await FormDataRestClient.post(
                    GRAPHQL_API, formData
                ).then((queryResult) => {
                    if (queryResult.data.errors) {
                        action = updateActionErrors(action, queryResult.data.errors);
                    }else if(queryResult.data.data.addTenant.errorMessage){
                        action = updateActionErrors(action, queryResult.data.data.addTenant.errorMessage);
                    } else {
                        let modPayload = {
                            ...action.payload,
                            ...queryResult.data.data.addTenant.tenant
                        }

                        action = {
                            ...action,
                            payload: parseTenant(modPayload)
                        };
                        refreshUnitsForProperties([queryResult.data.data.addTenant.tenant.propertyId]);
                    }
                });
            } catch (error) {
                console.error(error);
                action = updateActionErrors(action, error)
            }

            break;
        case UPDATE_TENANT:
            try {
                let tenant = action.payload;
                const previousTenant = storeAPI.getState().tenants[tenant.tenantId] || {};
                const query = UpdateTenantMutation(tenant)
                const formData = getFormData(query, action.payload.fileUpload);
                await FormDataRestClient.post(
                    GRAPHQL_API, formData
                ).then((queryResult) => {
                    if (queryResult.data.errors) {
                        action = updateActionErrors(action, queryResult.data.errors);
                    }else if(queryResult.data.data.updateTenant.errorMessage){
                        action = updateActionErrors(action, queryResult.data.data.updateTenant.errorMessage);
                    }else {
                        action = ({
                            ...action,
                            payload: parseTenant({
                                ...tenant,
                                ...queryResult.data.data.updateTenant.tenant
                            })
                        });
                        refreshUnitsForProperties([
                            previousTenant.propertyId,
                            queryResult.data.data.updateTenant.tenant.propertyId
                        ]);
                    }
                });
            } catch (error) {
                console.error(error);
                action = updateActionErrors(action, error)
            }
            break;
        case DELETE_TENANT:
            let tenant = action.payload;
            try {
                await graphqlClient({
                    data: {
                        query: DeleteTenantMutation(tenant.tenantId)
                    }
                }).then((queryResult) => {
                    if (queryResult.data.errors) {
                        action = updateActionErrors(action, queryResult.data.errors);
                    } else {
                        refreshUnitsForProperties([tenant.propertyId]);
                    }
                });
            } catch (error) {
                console.error(error);
                action = updateActionErrors(action, error);
            }
            break;
        case FETCH_TENANT_DATA:
            action = await fetchTenantDataMiddleware(action);
            break;
        case SHIFT_TENANT:
            let payload = action.payload;
            try {
                const previousTenant = storeAPI.getState().tenants[payload.tenantId] || {};
                await graphqlClient({
                    data: {
                        query: ShiftTenantMutation(payload.tenantId, payload.unitId)
                    }
                }).then((queryResult) => {
                    if (queryResult.data.errors) {
                        action = updateActionErrors(action, queryResult.data.errors);
                    }else if(queryResult.data.data.shiftTenant.errorMessage){
                        action = updateActionErrors(action, queryResult.data.data.shiftTenant.errorMessage);
                    }else{
                        const data = queryResult.data.data.shiftTenant;
                        action = ({
                            ...action,
                            payload: {
                                ...payload,
                                ...data,
                                tenant: parseTenant(data.tenant)
                            }
                        });
                        refreshUnitsForProperties([
                            previousTenant.propertyId,
                            data.tenant.propertyId
                        ]);
                    }
                });
            } catch (error) {
                console.error(error);
                action = updateActionErrors(action, error);
            }
            break;
    }

    return next(action);
};

const fetchPropertyTenantsMiddleware = async (action) => {
    try{
        const payload = action.payload;
        const query = queryPropertyTenants(payload.propertyIds, payload.searchText);
        await graphqlClient({
            data: {
                query
            },
        }).then((queryResult) => {
            if (queryResult.data.errors) {
                action = updateActionErrors(action, queryResult.data.errors);
            } else {
                let tenants = queryResult.data.data.propertySpecificTenants;
                if (tenants.length > 0){
                    tenants = tenants.map(parseTenant);
                }
                action = {
                    ...action,
                    payload: {
                        ...action.payload,
                        tenants
                    },
                };
            }
        });

    } catch(error){
        console.log(error);
        action = updateActionErrors(action, error);
    }
    return action;
}
const fetchTenantsMiddleware = async (action) => {
    try {
        const query = getTenantsQuery(action.payload);
        await graphqlClient({
            data: {
                query
            },
        }).then((queryResult) => {
            if (queryResult.data.errors) {
                action = updateActionErrors(action, queryResult.data.errors);
            } else {
                let { tenants, summary, next } = queryResult.data.data.allTenants;
                tenants = tenants.map(parseTenant);
                action = {
                    ...action,
                    payload: {
                        ...action.payload,
                        tenants
                    },
                    offset: next,
                    summary
                };
            }
        });
    } catch (error) {
        console.log(error);
        action = updateActionErrors(action, error);
    }
    return action;
}

const fetchTenantDataMiddleware = async (action) => {
    try {
        const query = GetTenantDataQuery(action.payload.tenantId);
        await graphqlClient({
            data: {
                query
            },
        }).then((queryResult) => {
            if (queryResult.data.errors) {
                action = updateActionErrors(action, queryResult.data.errors);
            } else {
                const tenantData = queryResult.data.data.getTenant;
                action = {
                    ...action,
                    payload: {
                        ...action.payload,
                        tenantData
                    },
                };
            }
        });
    } catch (error) {
        console.log(error);
        action = updateActionErrors(action, error);
    }
    return action;
};

async function fetchTenants(dispatch, getState) {

    let tenants = {};
    //create the list of properties and pass it to the query function
    let propertyIDs = [];
    let storedProperties = getState().properties;
    let storedUnits = getState().units;

    for (const element of Object.keys(storedProperties)) {
        propertyIDs.push(String(element));
    }

    try {
        await graphqlClient({
            data: {
                query: GetAllTenantsDataQuery(propertyIDs)
            }
        }).then((queryResult) => {
            queryResult.data.data.allTenantDataUsingList.map((tenant) => (
                tenants[tenant.tenantId] = parseTenant(tenant)
            ));

            let initialData = { tenants };
            dispatch({ type: FETCH_TENANTS, payload: initialData });
        }).then(() => {
            let properties = { ...storedProperties };

            for (const [key, value] of Object.entries(tenants)) {
                if (!properties[value.propertyId]) {
                    properties[value.propertyId] = {
                        "units": {
                            [value.unitId]: {
                                [value.tenantId]: value.tenantId
                            }
                        }
                    };
                } else if (!properties[value.propertyId]["units"]) {
                    properties[value.propertyId]["units"] = {
                        [value.unitId]: {
                            [value.tenantId]: value.tenantId
                        }
                    };
                } else if (!properties[value.propertyId]["units"][value.unitId]) {
                    properties[value.propertyId]["units"][value.unitId] = {
                        [value.tenantId]: value.tenantId
                    }
                } else {
                    properties[value.propertyId]["units"][value.unitId][value.tenantId] = value.tenantId;
                }
            }
            dispatch({ type: LOAD_PROPERTIES, payload: { properties } });
        });
    } catch (error) {
        console.error(error);
    }
}

export {
    tenantsMiddleware,
    fetchTenants
}